export interface BusinessInsightsRoutes {
    BasePath: string;
    LandingPagePath: string;
    MetricsHubPath: string;
    DrillDownPath: string;
    NotFound: string;
}

const basePath = "BusinessInsights";

export const routes: BusinessInsightsRoutes = {
    BasePath: `/${basePath}`,
    LandingPagePath: "/LandingPage",
    MetricsHubPath: "/MetricsHub/:category",
    DrillDownPath: "/DrillDown/:metric/:label",
    NotFound: "/NotFound"
};
